import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import TicketOwnerDialog from './TicketOwnerDialog';

class TicketsDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ticketForPrint: {}
        };

        this.getTicketStatusTexts = this.getTicketStatusTexts.bind(this);
        this.handlePrintTicket = this.handlePrintTicket.bind(this);
        this.handleCloseTicketDialog = this.handleCloseTicketDialog.bind(this);
        this.handleSaveAndContinue = this.handleSaveAndContinue.bind(this);
    }

    getTicketStatusTexts(ticket) {
        const { formData } = this.props;
        const {
            ticketIsPrintableText,
            ticketIsNotPrintableText,
            ticketIsAlreadyPrintedText
        } = formData;

        if (ticket.isPrintable && ticket.isAlreadyPrinted) {
            return ticketIsAlreadyPrintedText;
        }

        if (ticket.isPrintable && !ticket.isAlreadyPrinted) {
            return ticketIsPrintableText;
        }

        return ticketIsNotPrintableText;
    }

    handlePrintTicket(event, ticket) {
        event.preventDefault();
        if (!ticket.isPrintable) {
            return;
        }

        this.setState((prevState) => {
            return {
                ...prevState,
                ticketForPrint: ticket
            };
        });
    }

    handleCloseTicketDialog(event) {
        event.preventDefault();
        this.setState((prevState) => {
            return {
                ...prevState,
                ticketForPrint: {}
            };
        });
    }

    handleSaveAndContinue(firstNameValue, lastNameValue) {
        const { onSaveAndContinueClick } = this.props;
        const { ticketForPrint } = this.state;
        onSaveAndContinueClick({ firstNameValue, lastNameValue, ticketForPrint });
    }

    render() {
        const { tickets, formData } = this.props;
        const { ticketForPrint } = this.state;
        return tickets.map((ticket, index) => {
            const isLast = index === tickets.length - 1;
            return <Fragment key={ticket.ticketId}>
                <div className={`ticket-container ${isLast ? 'last' : formMessageConstants.emptyString}`} >
                    <div className='description'>
                        <div className='type'><span className='header'>Type</span> {ticket.ticketType}</div>
                        <div className='ticket-number'><span className='header'>Ticket number</span> {ticket.ticketId}</div>
                        <div className='file-number'><span className='header'>File number</span> {ticket.fileId}</div>
                        <span className='print-message'>{this.getTicketStatusTexts(ticket)}</span>
                    </div>
                    <div className='print-container'>
                        <a
                            className={`print-button ${ticket.isPrintable}`}
                            onClick={(event) => { this.handlePrintTicket(event, ticket); }}>
                            <svg
                                aria-hidden='true'
                                focusable='false'
                                data-prefix='fal'
                                data-icon='print'
                                role='img'
                                xmlns='http://www.w3.org/2000/svg'
                                viewBox='0 0 512 512'
                                className=''>
                                <path
                                    fill='currentColor'
                                    d='M432 192h-16v-82.75c0-8.49-3.37-16.62-9.37-22.63L329.37 9.37c-6-6-14.14-9.37-22.63-9.37H126.48C109.64 0 96 14.33 96 32v160H80c-44.18 0-80 35.82-80 80v96c0 8.84 7.16 16 16 16h80v112c0 8.84 7.16 16 16 16h288c8.84 0 16-7.16 16-16V384h80c8.84 0 16-7.16 16-16v-96c0-44.18-35.82-80-80-80zM320 45.25L370.75 96H320V45.25zM128.12 32H288v64c0 17.67 14.33 32 32 32h64v64H128.02l.1-160zM384 480H128v-96h256v96zm96-128H32v-80c0-26.47 21.53-48 48-48h352c26.47 0 48 21.53 48 48v80zm-80-88c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z'
                                    className=''>
                                </path>
                            </svg>
                        </a>
                    </div>
                </div>
                {ticketForPrint.ticketId === ticket.ticketId ?
                    <TicketOwnerDialog
                        formData={formData}
                        handleCloseTicketDialog={this.handleCloseTicketDialog}
                        onSaveAndContinueClick={this.handleSaveAndContinue}></TicketOwnerDialog> : null}
            </Fragment>;
        });
    }
}

TicketsDisplay.propTypes = {
    tickets: PropTypes.array.isRequired,
    onSaveAndContinueClick: PropTypes.func.isRequired,
};

export default TicketsDisplay;
